import * as actionTypes from './actionTypes';
import admSvc from '../../axios-admsvc';
import adminDisableSvc from '../../axios-admsvc-disable';
import {setSearchPageMessage} from "./search";
import { LS_OTP_VERIFIED, LS_OTP_VERIFIED_NUMBER, LS_DISABLE_IDENTITY_ATTEST_FAIL, SDK_ENABLE, NO_RECOVERY_OPTIONS_AVAILABLE, SUCCESS, INFO, DISABLE_REASONS, DISABLE_SUCCESS, CHECK_BRIOVA_PRTL_SHORTNAME_FLAG, SDK_PORTAL_LIST, OPTUMLABSLOOP, ID_TYPE_NEW, SESSION_USERNAME, SESSION_TIER1USER, HSID_PARTIAL_REGISTRATION} from '../../shared/Constants';
import * as urls from '../../shared/ApplicationUrls';
import { modifyAccountSuccess, modifyAccountFailure } from '../actions/personalInfo';
import { getPortalNameForEligibilityScreen } from '../../shared/utility';
import { startTimer } from './timer';

export const selectMember = (selectedMember, idType, showLoader = true) => {
  return (dispatch) => {
    dispatch(setSelectedMember(selectedMember, showLoader));
    dispatch(eraseAccountSecurityReducers())
    const id = selectedMember.uuid ? selectedMember.uuid : selectedMember.id;
    admSvc
      .get(
        "/search/account/memberIdEligibility/V3.0?id=" +
          id +
          "&idType=" +
          idType
      )
      .then((response) => {
        // console.log("[Member Action] memberPayLoad", response, response.data.memberPayLoad.member[0]);
        // let memberData = response.data.memberPayLoad.essoData?Object.assign(response.data.memberPayLoad.member[0], {essoData: response.data.memberPayLoad.essoData}):response.data.memberPayLoad.member[0];
        let member = null;
        if (response.data.memberPayLoad.member) {
          member = response.data.memberPayLoad.member[0]
            ? response.data.memberPayLoad.member[0]
            : null;
        }
        if (
          response.data.adminIncidentResponse &&
          response.data.adminIncidentResponse.incidentResponse
        ) {
          dispatch(
            fetchImpactedMemberDataSuccess(
              response.data.adminIncidentResponse.incidentResponse
            )
          );
          // dispatch(
          //   setIncidentMembersList(
          //     response.data.adminIncidentResponse.memberPayLoadList
          //   )
          // );
        } else if (
          !response.data.adminIncidentResponse &&
          response.data.memberPayLoad?.essoData?.essoStatus?.enableDisableStatus === "disabled"
        ) {
          dispatch(setDisabledMemberStatus(response.data.memberPayLoad?.essoData?.essoStatus));
        } else if (response.data.memberPayLoad.member) {
          response.data.memberPayLoad.idType = idType;
          response.data.memberPayLoad.priImpactedFlag = "Primary";
          // dispatch(setIncidentMembersList([response.data.memberPayLoad]));
        }
        let memberData = {
          ...member,
          essoData: response.data.memberPayLoad.essoData,
          hsidLastLoginDate: response.data.memberPayLoad.hsidLastLoginDate,
          priImpactedFlag: "Primary",
          idType: ID_TYPE_NEW[idType] ? ID_TYPE_NEW[idType] : idType,
          // essoData: {
          //     ...response.data.memberPayLoad.essoData,
          //     accountStatus: {
          //         ...response.data.memberPayLoad.essoData.accountStatus,
          //         aaStatus: "UNVERIFIED"
          //     },
          //     essoStatus: {
          //         ...response.data.memberPayLoad.essoData.essoStatus,
          //         ldapLockStatus: "locked"
          //     }
          // }
        };
        dispatch(fetchMemberDataSuccess(memberData, idType, !showLoader));
      })
      .catch((error) => {
        //console.log(error);
        // Promise.reject(error);
        dispatch(fetchMemberDataFailure(error));
      });
  };
};

export const setDisabledMemberStatus = (data) => {
  return {
    type: actionTypes.SET_DISABLED_MEMBER_STATUS,
    payload: data,
  };
};

export const eraseAccountSecurityReducers = () => {
  return {
    type: actionTypes.ERASE_ACCOUNT_SECURITY_REDUCERS
  }
}

export const fetchMemberData = (uuid, idType) => {
  return (dispatch) => {
    admSvc
      .get(
        "/search/account/memberIdEligibility/V3.0?id=" +
          uuid +
          "&idType=" +
          idType
      )
      .then((response) => {
        let member =
          response.data.memberPayLoad && response.data.memberPayLoad?.member?.[0]
            ? response.data.memberPayLoad?.member?.[0]
            : null;
        let memberData = {
          ...member,
          essoData: response.data.memberPayLoad.essoData,
          hsidLastLoginDate: response.data.memberPayLoad.hsidLastLoginDate,
        };
        dispatch(fetchMemberDataSuccess(memberData, idType));
      })
      .catch((error) => {
        //console.log(error);
        // Promise.reject(error);
        dispatch(fetchMemberDataFailure(error));
      });
  };
};

export const setSelectedMember = (selectedMember, showLoader) => {
  // console.log("[Member Action] setSelectedMember", selectedMember);
  return {
    type: actionTypes.SELECT_MEMBER,
    selectedMember: selectedMember,
    showLoader: showLoader,
  };
};

export const fetchMemberDataSuccess = (memberData, idType, persistSmsMessage) => {
  // console.log("[Member Action] fetchMemberDataSuccess", memberData);
  return {
    type: actionTypes.FETCH_MEMBER_DATA_SUCCESS,
    memberData: memberData,
    idType: idType,
    persistSmsMessage: persistSmsMessage,
  };
};

export const fetchMemberDataFailure = (error) => {
  return {
    type: actionTypes.FETCH_MEMBER_DATA_FAILURE,
    error: error,
  };
};

export const rebuildCache = (memberPortalData) => {
    //need to change the code later to diplay displayNames for all the portals
    const portalNameMessageDisplay = memberPortalData.portalShortNm === OPTUMLABSLOOP ? memberPortalData.portalDisplayName : memberPortalData.portalShortNm;
    return dispatch => {

        //console.log("[Member Actions] rebuild cache", memberPortalData);
        dispatch(rebuildCacheStart(memberPortalData.portalShortNm));
        console.log("Is Sdk portal",memberPortalData);
        let url = ( memberPortalData.portalShortNm.indexOf("BRIOVA") > -1 || memberPortalData.portalShortNm.indexOf("RX") > -1) ? '/members/cache/rebuild': '/member/eligibilities/v1.0/status';
        const rebuildCacheRequest = ( memberPortalData.portalShortNm.indexOf("BRIOVA") === -1 && memberPortalData.portalShortNm.indexOf("RX") === -1)
            ? {portals: [
                memberPortalData.portalShortNm
            ],
            uuid: memberPortalData.uuid,
            userName:memberPortalData.userName,
            sdkPortal: memberPortalData.isSdkPortal
             }
            :{
                dob: memberPortalData.portalDob,
                firstName: memberPortalData.portalFirstNm,
                lastName: memberPortalData.portalLastNm,
                prtlShrtName: CHECK_BRIOVA_PRTL_SHORTNAME_FLAG && memberPortalData.portalShortNm === 'BRIOVA' ? 'OSP' : memberPortalData.portalShortNm,
                smUniversalid: memberPortalData.uuid,
                uuid: memberPortalData.uuid,
                portalPolicyNbr: memberPortalData.portalPolicyNbr ? memberPortalData.portalPolicyNbr : "",
                userName:memberPortalData.userName
            }
        admSvc.post(url, rebuildCacheRequest)
            .then(response => {
                // console.log("[Member Actions] rebuildCache response", response);
                if(( memberPortalData.portalShortNm.indexOf("BRIOVA") > -1 || memberPortalData.portalShortNm.indexOf("RX") > -1) && response.data.AuthResponse && response.data.AuthResponse.errorCode) {
                    let errorCode = response.data.AuthResponse.errorCode
                    errorCode = errorCode.replace(/BRIOVA/gi, "OSP-RX")
                    dispatch(rebuildCacheFailure(portalNameMessageDisplay, errorCode));
                }else if(( memberPortalData.portalShortNm.indexOf("BRIOVA") > -1 || memberPortalData.portalShortNm.indexOf("RX") > -1) && response.data.path){
                    dispatch(rebuildCacheFailure(portalNameMessageDisplay, NO_RECOVERY_OPTIONS_AVAILABLE));
                }else if(( memberPortalData.portalShortNm.indexOf("BRIOVA") === -1 && memberPortalData.portalShortNm.indexOf("RX") === -1) && response.data.payload && response.data.payload[memberPortalData.portalShortNm].status !=='ELIGIBLE') {
                    dispatch(rebuildCacheFailure(portalNameMessageDisplay, response.data.payload[memberPortalData.portalShortNm].error));
                }
                else {
                    dispatch(rebuildCacheSuccess(portalNameMessageDisplay));
                }
            })
            .catch(error => {
                //console.log("[Member Actions] rebuildCache error", error);
                dispatch(rebuildCacheFailure(rebuildCacheRequest.prtlShrtName));
                // Promise.reject(error);
            });
    }
}

export const rebuildCacheStart = (portalShortNm) => {
  return {
    type: actionTypes.REBUILD_CACHE_START,
    portalName: portalShortNm,
  };
};

export const rebuildCacheSuccess = (portalShortName) => {
  return {
    type: actionTypes.REBUILD_CACHE_SUCCESS,
    portalShortName: portalShortName,
  };
};

export const rebuildCacheFailure = (portalShortName, errorCode) => {
  return {
    type: actionTypes.REBUILD_CACHE_FAILURE,
    portalShortName: portalShortName,
    errorCode: errorCode,
  };
};

export const addMemberEligibilitySuccess = (operation) => {
  //console.log("[Member Action] addMemberEligibilitySuccess", operation);
  return {
    type: actionTypes.ADD_MEMBER_ELIGIBILITY,
    // memberElig: portalElig,
    operation: operation,
  };
};

export const deleteAccountSuccess = (uuid) => {
  return {
    type: actionTypes.DELETE_ACCOUNT_SUCCESS,
    uuid: uuid,
  };
};

export const deleteAccountFailure = (uuid, errorCode) => {
  return {
    type: actionTypes.DELETE_ACCOUNT_FAILURE,
    uuid: uuid,
    errorCode: errorCode,
  };
};

export const deleteAccount = (formData, history, url) => {
  return (dispatch) => {
    //console.log("[Member Actions] deleteAccount from Super User", uuid);
    admSvc
      .post("/members/deleteAccount/v2.0", formData)
      .then((response) => {
        //console.log("[Member Actions] deleteAccount from Super User Response: ", response);
        if (response.data.status && response.data.status.code === SUCCESS) {
          //do not call for NULL HSID accounts
          if (formData.uuid) {
            dispatch(deleteAccountSuccess(formData.uuid));
            dispatch(updateCache(formData.uuid));
          }
          if (history) {
            //console.log("[Member Actions] deleteAccount - setSearchPageMessage ");
            history.push(url);
            dispatch(
              setSearchPageMessage({
                type: "Success",
                info: { message: "User Account deleted successfully." },
              })
            );
          }
        } else {
          dispatch(
            deleteAccountFailure(formData.uuid, response.data?.status?.message)
          );
        }
      })
      .catch((error) => {
        //console.log("[Member Actions] deleteAccount error", error);
        dispatch(deleteAccountFailure(formData.uuid));
        // Promise.reject(error);
      });
  };
};

export const updateCache = (uuid) => {
  return (dispatch) => {
    //console.log("[Member Actions] updateCache from Super User", uuid);
    admSvc
      .post("/members/updateCache?uuid=" + uuid)
      .then((response) => {
        //console.log("[Member Actions] updateCache from Super User Response: ", response);
        if (response.data.status && response.data.status.code === SUCCESS) {
          dispatch(updateCacheSuccess(uuid));
        } else {
          dispatch(updateCacheFailure(uuid));
        }
      })
      .catch((error) => {
        //console.log("[Member Actions] updateCache error", error);
        dispatch(updateCacheFailure(uuid));
        // Promise.reject(error);
      });
  };
};

export const updateCacheSuccess = (uuid) => {
  return {
    type: actionTypes.UPDATE_CACHE_SUCCESS,
    uuid: uuid,
  };
};

export const updateCacheFailure = (uuid, errorCode) => {
  return {
    type: actionTypes.UPDATE_CACHE_FAILURE,
    uuid: uuid,
    errorCode: errorCode,
  };
};

export const updateHsidInfo = (memberInfo, fieldsModified) => {
  return (dispatch) => {
    //console.log("[Member Actions] updateHsidInfo from Super User", memberInfo);
    //console.log("[Member Actions] updateHsidInfo from Super User fieldsModified : ", fieldsModified);
    admSvc
      .post("/members/addEligibility", memberInfo)
      .then((response) => {
        //console.log("[Member Actions] updateHsidInfo Response: ", response.data, response.data[0], response.data[0].memberPortalAttributeList[0]);
        dispatch(updateHsidInfoSuccess(fieldsModified, response));
        dispatch(updateCache(memberInfo.healthSafeId));
      })
      .catch((error) => {
        //console.log("[Member Actions] updateHsidInfo error", error);
        dispatch(updateHsidInfoFailure(fieldsModified, error));
        // Promise.reject(error);
      });
  };
};

export const updateHsidInfoSuccess = (fieldsModified, response) => {
  return {
    type: actionTypes.UPDATE_HSID_INFO_SUCCESS,
    fieldsModified: fieldsModified,
    response: response,
  };
};

export const updateHsidInfoFailure = (fieldsModified, errorCode) => {
  return {
    type: actionTypes.UPDATE_HSID_INFO_FAILURE,
    fieldsModified: fieldsModified,
    errorCode: errorCode,
  };
};

export const personalInfoSuccess = (personalInfo, response) => {
  // console.log("[Member Action] personalInfoSuccess", personalInfo, response);
  return {
    type: actionTypes.PERSONAL_INFO_SUCCESS,
    personalInfo: personalInfo,
    response: response,
  };
};

export const unlockUser = (userData) => {
  return (dispatch) => {
    admSvc
      .post("/members/unlockUser", userData)
      .then((response) => {
        // console.log("[Member Reducer] unlockUser: response", response.data, response.data.code, response.data.code===200, response.data.code==="200", response.data.description);
        if (response.data.code === "200" || response.data.code === 200) {
          // console.log("[Member Reducer] unlockUser: response: inside if block");
          dispatch(unlockUserSuccess(response.data.description));
        } else {
          // console.log("[Member Reducer] unlockUser: response: inside else block");
          dispatch(
            unlockUserFailure({ description: response.data.description })
          );
        }
      })
      .catch((error) => {
        // console.log("[Member Reducer] unlockUser: response: inside error block", error);
        dispatch(unlockUserFailure(error));
      });
  };
};

export const unlockUserStart = () => {
  return {
    type: actionTypes.UNLOCK_USER_START,
  };
};

export const unlockUserSuccess = (message) => {
  return {
    type: actionTypes.UNLOCK_USER_SUCCESS,
    message: message,
  };
};

export const unlockUserFailure = (error) => {
  return {
    type: actionTypes.UNLOCK_USER_FAILURE,
    error: error,
  };
};

export const unlockRba = (userData, idType) => {
  return (dispatch) => {
    admSvc
      .post(urls.UNLOCK_RBA, userData)
      .then((response) => {
        // console.log("[Member Reducer] unlockRba: response", response.data, response.data.status, response.status===200, response.data.status, response.data.description);
        if (response.status === 200 && response.data.status === SUCCESS) {
          // console.log("[Member Reducer] unlockRba: response: inside if block");
          if (userData.headlessUser) {
            dispatch(
              unlockRbaSuccess(
                "Please have headless member SSO back and they will be prompted to setup the recovery options",
                true
              )
            );
          } else {
            dispatch(unlockRbaSuccess("User account is unlocked", false));
          }
          dispatch(fetchMemberData(userData.uuid, idType));
        } else {
          // console.log("[Member Reducer] unlockRba: response: inside else block");
          dispatch(
            unlockRbaFailure({ description: response.data.description })
          );
        }
      })
      .catch((error) => {
        // console.log("[Member Reducer] unlockRba: response: inside error block", error);
        dispatch(unlockRbaFailure(error));
      });
  };
};

export const unlockRbaStart = () => {
  return {
    type: actionTypes.UNLOCK_RBA_START,
  };
};

export const unlockRbaSuccess = (message, headlessUser) => {
  return {
    type: actionTypes.UNLOCK_RBA_SUCCESS,
    message: message,
    headlessUser: headlessUser,
  };
};

export const unlockRbaFailure = (error) => {
  return {
    type: actionTypes.UNLOCK_RBA_FAILURE,
    error: error,
  };
};

export const enableDisableStart = () => {
  return {
    type: actionTypes.ENABLE_DISABLE_ACCOUNT_START,
  };
};

export const enableDisableAccountSuccess = (status) => {
  return {
    type: actionTypes.ENABLE_DISABLE_ACCOUNT_SUCCESS,
    status: status,
  };
};

export const enableDisableFailure = (error) => {
  return {
    type: actionTypes.ENABLE_DISABLE_FAILURE,
    error: error,
  };
};

export const enableDisableAccountFailure = (error) => {
  return {
    type: actionTypes.ENABLE_DISABLE_ACCOUNT_FAILURE,
    error: error,
  };
};

export const enableDisableAccount = (userData, flag) => {
  let requestUrl = "/members/esso/enablement";
  let status = null;
  if(!localStorage.getItem(SESSION_USERNAME)) {
    return {
      type: actionTypes.ENABLE_DISABLE_ACCOUNT_FAILURE,
      error: {errorMsg: "Cannot Proceed without agent username! Please refresh the page and try again."}
    };
  }
  return (dispatch) => {
    dispatch(enableDisableStart());
    if (flag === "disabled") {
      status = "enabled";
      userData = {...userData, enableUser: true}
    } else {
      userData = {...userData, enableUser: false}
      status = "disabled";
    }
    //console.log("[Member Actions] enableDisableAccount ", userData, "flag=" , flag);
    admSvc
      .post(requestUrl, userData)
      .then((response) => {
        //console.log("[Member Reducer] enableDisableAccount: response", response.data, response.data.status, response.status===200, response.data.status, response.data.description);
        if (
          response.data.status.code === SUCCESS &&
          response.data.payload[0] &&
          response.data.payload[0].status &&
          response.data.payload[0].status === SUCCESS
        ) {
          // console.log("[Member Reducer] enableDisableAccount: response: inside if block");
          const passwordStatus = response.data.payload[0].Resource?.UserPayload?.UserDetail?.UserAccountStatus?.passwordStatus;
          if(!passwordStatus || ((flag === "disabled" && passwordStatus==='ADMINISTRATIVE_LOCK') || 
          (flag !== "disabled" && passwordStatus!=='ADMINISTRATIVE_LOCK'))) {
            dispatch(enableDisableAccountFailure({errorMsg:`Unable to ${flag === "disabled" ? 'enable':'disable'} user`}));
          } else {
            dispatch(enableDisableAccountSuccess(status));
            if (status === "disabled")
              localStorage.setItem(
                DISABLE_SUCCESS,
                " This account has been successfully disabled. Please escalate for further assistance."
              );
            else localStorage.removeItem(DISABLE_SUCCESS);
            // let eligInfo = {"uuid": userData.hsid}
            // dispatch(selectMember(eligInfo));
            
            let eligInfo = {"uuid": userData.hsid}
            dispatch(selectMember(eligInfo));
          }
        } else if (
          response.data.status.message === SUCCESS &&
          response.data.payload &&
          response.data.payload.status &&
          response.data.payload.status === SUCCESS
        ) {
          const passwordStatus = response.data.payload.Resource?.UserPayload?.UserDetail?.UserAccountStatus?.passwordStatus;
          if(!passwordStatus || ((flag === "disabled" && passwordStatus==='ADMINISTRATIVE_LOCK') || 
          (flag !== "disabled" && passwordStatus!=='ADMINISTRATIVE_LOCK'))) {
            dispatch(enableDisableAccountFailure({errorMsg:`Unable to ${flag === "disabled" ? 'enable':'disable'} user`}));
          } else {
            localStorage.removeItem(DISABLE_SUCCESS);
            dispatch(enableDisableAccountSuccess(status));
          }
        } else if (
          response.data.status.code === SUCCESS &&
          response.data.payload[0] &&
          response.data.payload[0].status &&
          response.data.payload[0].status === "FAIL"
        ) {
          dispatch(enableDisableFailure(response.data.status.message));
        } else {
          dispatch(enableDisableAccountFailure({errorMsg:`Unable to ${flag === "disabled" ? 'enable':'disable'} user`}));
        }
      })
      .catch((error) => {
        dispatch(enableDisableAccountFailure({errorMsg:`Unable to ${flag === "disabled" ? 'enable':'disable'} user`}));
      });
  };
};

export const updateIncident = (userData) => {
  let requestUrl = null;
  let status = null;
  return (dispatch) => {
    dispatch(enableDisableStart());
    requestUrl = "/incident/members/account/disablement";
    status = "disabled";
    //console.log("[Member Actions] enableDisableAccount ", userData, "flag=" , flag);
    admSvc
      .put(requestUrl, userData)
      .then((response) => {
        //console.log("[Member Reducer] enableDisableAccount: response", response.data, response.data.status, response.status===200, response.data.status, response.data.description);
        if (
          response.data.status.code === SUCCESS &&
          response.data.payload[0] &&
          response.data.payload[0].status &&
          response.data.payload[0].status === SUCCESS
        ) {
          // console.log("[Member Reducer] enableDisableAccount: response: inside if block");
          // let eligInfo = {"uuid": userData.hsid}
          // dispatch(selectMember(eligInfo));
          dispatch(enableDisableAccountSuccess(status));
        } else if (
          response.data.status.message === SUCCESS &&
          response.data.payload &&
          response.data.payload.status &&
          response.data.payload.status === SUCCESS
        ) {
          localStorage.removeItem(DISABLE_SUCCESS);
          dispatch(enableDisableAccountSuccess(status));
        } else if (
          response.data.status.code === SUCCESS &&
          response.data.payload[0] &&
          response.data.payload[0].status &&
          response.data.payload[0].status === "FAIL"
        ) {
          dispatch(enableDisableFailure(response.data.status.message));
        } else {
          dispatch(enableDisableAccountFailure(response.data.error));
        }
      })
      .catch((error) => {
        dispatch(enableDisableAccountFailure(error));
      });
  };
}

export const getReasonList = () => {
  return (dispatch) => {
    admSvc
      .get("/members/disableEnableReasons")
      .then((response) => {
        dispatch(setReasonList(response.data));
      })
      .catch((error) => {
        dispatch(getReasonFailure(error));
      });
  };
};

export const getFeatureReasonsList = (feature) => {
  return (dispatch) => {
    admSvc
      .get(`/members/reasons/${feature}`)
      .then((response) => {
        dispatch(setFeatureReasonList(response.data, feature));
      })
      .catch((error) => {
        dispatch(getFeatureReasonFailure(error, feature));
      });
  };
};

export const getReasonFailure = (error) => {
  return {
    type: actionTypes.SET_BULKDISABLE_RSN,
    response: error,
  };
};

export const getFeatureReasonFailure = (error, feature) => {
  return {
    type: actionTypes.SET_FEATURE_RSN,
    response: error,
    feature,
  };
};

export const setReasonList = (response) => {
  localStorage.setItem(DISABLE_REASONS, JSON.stringify(response.payload));
  const reasonList = localStorage.getItem(DISABLE_REASONS);
  return {
    type: actionTypes.SET_BULKDISABLE_RSN,
    rsnList: reasonList,
  };
};

export const setFeatureReasonList = (response, feature) => {
  localStorage.setItem(feature.toUpperCase()+'ReasonList', response.payload ? JSON.stringify(response.payload): '[]');
  const reasonList = localStorage.getItem(feature.toUpperCase()+'ReasonList');
  return {
    type: actionTypes.SET_FEATURE_RSN,
    rsnList: reasonList,
    feature: feature+'ReasonList',
  };
};

export const modalSpinnerStart = () => {
  return {
    type: actionTypes.RESET_ACCOUNT_START,
  };
};

export const resetPassword = (userData) => {
  return (dispatch) => {
    admSvc
      .post("/members/resetPassword", userData)
      .then((response) => {
        //console.log("[Member Reducer] resetPassword: response", response.data);
        if (response.data.status && response.data.status.code === SUCCESS) {
          // console.log("[Member Reducer] unlockRba: response: inside if block");
          dispatch(resetPasswordSuccess(response.data.status.message));
        }
      })
      .catch((error) => {
        // console.log("[Member Reducer] unlockRba: response: inside error block", error);
        dispatch(resetPasswordFailure(error));
      });
  };
};

export const resetPasswordSuccess = (message) => {
  return {
    type: actionTypes.RESET_PWD_SUCCESS,
    message: message,
  };
};

export const resetPasswordFailure = (error) => {
  return {
    type: actionTypes.RESET_PWD_FAILURE,
    error: error,
  };
};

export const resetSecurityQues = (userData) => {
  return (dispatch) => {
    admSvc
      .post("/members/account/recovery", userData)
      .then((response) => {
        //console.log("[Member Reducer] resetSecurityQues: response", response.data);
        if (
          response.data.status &&
          (response.data.status.code === SUCCESS ||
            response.data.status.code === INFO)
        ) {
          dispatch(resetSQSuccess(response.data));
        } else {
          dispatch(resetSQFailure(response.data.status.message));
        }
      })
      .catch((error) => {
        // console.log("[Member Reducer] unlockRba: response: inside error block", error);
        dispatch(resetSQFailure(error.data.error.errorDesc));
      });
  };
};

export const resetSQSuccess = (response) => {
  return {
    type: actionTypes.RESET_SQ_SUCCESS,
    message: response.status.message,
    code: response.status.code,
  };
};

export const resetSQFailure = (error) => {
  return {
    type: actionTypes.RESET_SQ_FAILURE,
    error: error,
  };
};

export const verifyEmailorPhone = (userData) => {
  return (dispatch) => {
    admSvc
      .post("/members/verify/phone/email", userData)
      .then((response) => {
        //console.log("[Member Actions] verifyEmailorPhone: response", response.data);
        if (response.data.status && response.data.status.code === SUCCESS) {
          // console.log("[Member Reducer] unlockRba: response: inside if block");
          dispatch(verifyEmailorPhoneSuccess(response.data.status.message));
          dispatch(modifyAccountSuccess());
        } else {
          dispatch(verifyEmailorPhoneFailure(response.data.status.message));
          dispatch(modifyAccountFailure(response.data.status.message));
        }
      })
      .catch((error) => {
        // console.log("[Member Reducer] unlockRba: response: inside error block", error);
        dispatch(verifyEmailorPhoneFailure(error.message));
        dispatch(modifyAccountFailure(error.message));
      });
  };
};

export const verifyEmailorPhoneSuccess = (message) => {
  return {
    type: actionTypes.VERIFY_EMAILPHONE_SUCCESS,
    message: message,
  };
};

export const verifyEmailorPhoneFailure = (error) => {
  return {
    type: actionTypes.VERIFY_EMAILPHONE_FAILURE,
    error: error,
  };
};

export const updateUsernameSuccess = (message) => {
  return {
    type: actionTypes.UPDATE_USERNAME_SUCCESS,
    message: message,
  };
};

export const updateUsernameFailure = (error) => {
  return {
    type: actionTypes.UPDATE_USERNAME_FAILURE,
    error: error,
  };
};

// Delete phone starts here
export const deletePhone = (userData) => {
  return (dispatch) => {
    admSvc
      .post("/members/account/phonedel", userData)
      .then((response) => {
        if (response.data.status && response.data.status.code === SUCCESS) {
          dispatch(deletePhoneSuccess(response.data.status.message));
        } else {
          dispatch(deletePhoneFailure(response.data.status.message));
        }
      })
      .catch((error) => {
        dispatch(deletePhoneFailure(error.message));
      });
  };
};

export const deletePhoneSuccess = (message) => {
  return {
    type: actionTypes.DELETEPHONE_SUCCESS,
    message: message,
  };
};

export const deletePhoneFailure = (error) => {
  return {
    type: actionTypes.DELETEPHONE_FAILURE,
    error: error,
  };
};
// Delete phone ends here

export const deleteSecondaryEmail = (userData) => {
  return (dispatch) => {
    admSvc
      .post("/members/account/secondaryemail", userData)
      .then((response) => {
        if (response.data.status && response.data.status.code === SUCCESS) {
          dispatch(deleteSecondaryEmailSuccess(response.data.status.message));
        } else {
          dispatch(
            deleteSecondaryEmailFailure("Secondary Email Deletion Failed")
          );
        }
      })
      .catch((error) => {
        dispatch(deleteSecondaryEmailFailure(error.message));
      });
  };
};

export const deleteSecondaryEmailSuccess = (message) => {
  return {
    type: actionTypes.DELETE_SECONDARY_EMAIL_SUCCESS,
    message: message,
  };
};

export const deleteSecondaryEmailFailure = (error) => {
  return {
    type: actionTypes.DELETE_SECONDARY_EMAIL_FAILURE,
    error: error,
  };
};

export const generateSmsOtpToken = (userData, otpType) => {
  return (dispatch) => {
    dispatch(smsTokenStart());
    admSvc
      .post(otpType==='Phone' ? "/members/otp/sms" :"/members/otp/call", userData, {
          headers: {
            NewUI: "No"
          }
        })
      .then((response) => {
        //console.log("[Member Actions] generateSmsOtpToken: response", response.data);
        if (response.data.sessionid) {
          dispatch(smsOtpTokenSuccess(response.data, otpType));
          dispatch(setOtpGeneratedFlag(false));
        } else if (response.data.error.includes("is locked")) {
          dispatch(
            smsOtpTokenFailure(
              "Cannot generate code, please unlock RBA to proceed."
            )
          );
        } else if (response.data.error == "Country code or phone number is missing") {
          dispatch(
            smsOtpTokenFailure(
              "Country code and phone number are mandatory to generate OTP"
            )
          );
        } else {
          dispatch(
            smsOtpTokenFailure("Passcode cannot be generated. Please Try Again. If issue persists, please contact L.1.5 for further assistance.")
          );
        }
      })
      .catch((error) => {
        //console.log("Generate OTP TOken error response: ", error);
        dispatch(
          smsOtpTokenFailure("Passcode cannot be generated. Please Try Again. If issue persists, please contact L.1.5 for further assistance.")
        );
      });
  };
};

export const generateEmailOtpToken = (userData) => {
  return (dispatch) => {
    dispatch(smsTokenStart());
    admSvc
      .post("/members/otp/email", userData)
      .then((response) => {
        //console.log("[Member Actions] generateEmailOtpToken: response", response.data);
        if (response.data.sessionid) {
          dispatch(smsOtpTokenSuccess(response.data));
        } else if (response.data.error.includes("is locked")) {
          dispatch(
            smsOtpTokenFailure(
              "Cannot generate code, please unlock RBA to proceed."
            )
          );
        } else {
          dispatch(
            smsOtpTokenFailure("Failed to generate passcode. Please Try Again")
          );
        }
      })
      .catch((error) => {
        //console.log("Generate Email OTP TOken error response: ", error);
        dispatch(
          smsOtpTokenFailure("Failed to generate passcode. Please Try Again")
        );
      });
  };
};

export const verifyEmailOtpToken = (userData) => {
  return (dispatch) => {
    dispatch(smsTokenStart());
    admSvc
      .post("/members/otp/email/verifyToken", userData)
      .then((response) => {
        //console.log("[Member Actions] verifyEmailOtpToken: response", response.data);
        if (
          response.data &&
          response.data.authenticationStatus &&
          response.data.authenticationStatus === "AUTHENTICATED"
        ) {
          //if the otp is verified via email we store encrypted Id in the local storage to keep it alive even after reload
          localStorage.setItem(LS_OTP_VERIFIED, btoa(response.data.uuid));
          dispatch(verifyOtpTokenSuccess("Verified"));
        } else {
          if (
            response.data &&
            response.data.error &&
            response.data.error.includes("The user is locked")
          ) {
            dispatch(
              verifyOtpTokenLocked(
                "Failed to authenticate user with EMAIL.The user is locked"
              )
            );
          } else {
            dispatch(verifyOtpTokenFailure("Wrong Code"));
          }
        }
      })
      .catch((error) => {
        //console.log("Verify OTP TOken error response: ", error);
        dispatch(smsOtpTokenFailure("Wrong Code"));
      });
  };
};

export const smsTokenStart = () => {
  return {
    type: actionTypes.SMS_OTP_TOKEN_START,
  };
};

export const smsTokenStop = () => {
  return {
    type: actionTypes.SMS_OTP_TOKEN_STOP,
  };
};

export const smsOtpTokenSuccess = (genTokenResponse, otpType) => {
  return {
    type: actionTypes.SMS_OTP_TOKEN_SUCCESS,
    genTokenResponse: genTokenResponse,
    otpType
  };
};

export const smsOtpTokenFailure = (error) => {
  return {
    type: actionTypes.SMS_OTP_TOKEN_FAILURE,
    error: error,
  };
};

export const initiateAttest=(data, essoData, userType) => {
  return (dispatch) => {
    admSvc.post("/activity/event", data)
      .then((res)=>{
        if(data.eventStatus==='SUCCESS') {
          localStorage.setItem(LS_OTP_VERIFIED, btoa(data.uuid ));
          localStorage.setItem(LS_OTP_VERIFIED_NUMBER, btoa(JSON.stringify({countryCode: data.countryCode,number: data.phoneno })));
          dispatch(selectMember(essoData, essoData.idType, false))
          dispatch(initiateAttestFailure())
          dispatch(verifyOtpTokenSuccess(userType===SESSION_TIER1USER ? "2-Step Process Attested to, update fields unlocked" :""));
        } else {
          dispatch(initiateAttestFailure())
          localStorage.setItem(LS_DISABLE_IDENTITY_ATTEST_FAIL, btoa(data.uuid ));
          dispatch(verifyOtpTokenFailure(userType===SESSION_TIER1USER ? '2-Step Process Failed, please warm transfer to T1.5':""))
        }
        
      })
      .catch((e)=>{
        dispatch(initiateAttestFailure())
      })
  }
}

export const initiateAttestSuccess = () => {
  return {
    type: actionTypes.INITIATE_ATTEST_SUCCESS,
  };
};

export const initiateAttestFailure = () => {
  return {
    type: actionTypes.INITIATE_ATTEST_FAILURE,
  };
};

export const verifySmsOtpToken = (userData, essoDetails) => {
  return (dispatch) => {
    dispatch(smsTokenStart());
    admSvc
      .post("/members/otp/verifyToken", userData, {
          headers: {
            NewUI: "No"
          }
        })
      .then((response) => {
        //console.log("[Member Actions] verifySmsOtpToken: response", response.data);
        if (
          response.data &&
          response.data.authenticationStatus &&
          response.data.authenticationStatus === "AUTHENTICATED"
        ) {
          if(response.data.identityAssociationResponse && 
            response.data.identityAssociationResponse.result === 'PASS'
          ) {
            //if the otp is verified via email we store encrypted Id in the local storage to keep it alive even after reload
            localStorage.setItem(LS_OTP_VERIFIED, btoa(response.data.uuid ?? essoDetails.uuid));
            localStorage.setItem(LS_OTP_VERIFIED_NUMBER, btoa(JSON.stringify({countryCode: userData.countryCode,number: userData.phoneno })));
            dispatch(startTimer());
            dispatch(selectMember(essoDetails, essoDetails.idType, false))
            dispatch(verifyOtpTokenSuccess("Passcode Accepted and Identity Confirmed"));
            dispatch(initiateAttestFailure())
          } else {
            dispatch(selectMember(essoDetails, essoDetails.idType, false))
            const isDifferentNumber = userData.phoneno !== essoDetails.phoneno || userData.countryCode !== essoDetails.countryCode
            let phoneOnFileMessage = "Passcode Accepted to phone on file, but unable to confirm identity.";
            phoneOnFileMessage = essoDetails.idType != HSID_PARTIAL_REGISTRATION ? `${phoneOnFileMessage} Please perform 2-Step process.` : phoneOnFileMessage;

            dispatch(verifyOtpTokenFailure(isDifferentNumber ? 
              "Passcode Accepted to new phone, but unable to confirm identity.  Please escalate or try phone on file." : 
              phoneOnFileMessage
          ));
            if(!isDifferentNumber) {
              dispatch(initiateAttestSuccess())
            }
          }
          dispatch(setOtpGeneratedFlag(true));
        } else {
          if (
            response.data &&
            response.data.error &&
            response.data.error.includes("The user is locked")
          ) {
            dispatch(selectMember(essoDetails, essoDetails.idType, false))
            dispatch(
              verifyOtpTokenLocked(
                "Failed to authenticate user with SMS.The user is locked"
              )
            );
          } else if (
            response.data &&
            response.data.error &&
            response.data.error.includes("The user is disabled")
          ) {
            dispatch(selectMember(essoDetails, essoDetails.idType, false))
            dispatch(
              verifyOtpTokenLocked(
                "Failed to authenticate user with SMS.The user is disabled"
              )
            );
          } else {
            dispatch(verifyOtpTokenFailure("Wrong Passcode"));
          }
          dispatch(initiateAttestFailure())
        }
      })
      .catch((error) => {
        //console.log("Verify OTP TOken error response: ", error);
        dispatch(smsOtpTokenFailure("Wrong Code"));
      });
  };
};

export const verifyOtpTokenSuccess = (message) => {
  return {
    type: actionTypes.VERIFY_OTP_TOKEN_SUCCESS,
    message: message,
  };
};

export const verifyOtpTokenFailure = (error) => {
  return {
    type: actionTypes.VERIFY_OTP_TOKEN_FAILURE,
    error: error,
  };
};

export const verifyOtpTokenLocked = (error) => {
  return {
    type: actionTypes.VERIFY_OTP_TOKEN_LOCKED,
    error: error,
  };
};

export const setOtpDisplayMessage = (message) => {
  return {
    type: actionTypes.SET_OTP_DISPLAY_MESSAGE,
    message: message,
  };
};

export const setOtpGeneratedFlag = (flag) => {
  return {
    type: actionTypes.OTP_GENERATED_FLAG,
    flag: flag,
  }
}

export const deleteEligibility = (memberInfo, mbrPortalInfo, portals, history) => {
    const portalNameMessageDisplay = getPortalNameForEligibilityScreen(mbrPortalInfo.portalShortNm, portals);
    return dispatch => {
        dispatch(deleteEligibilityStart());
        //console.log("[Member Actions] deleteEligibility from Member Eligibility", memberInfo);
        admSvc.post("/members/deleteEligibility", memberInfo).then(response => {
                //console.log("[Member Actions] deleteEligibility Response: ", response.data);
                response.data.message === "Member Status update successful" ?
                    dispatch(deleteEligibilitySuccess(portalNameMessageDisplay, mbrPortalInfo?.memberPortalId)) :
                    dispatch(deleteEligibilityFailure(portalNameMessageDisplay));
        }).catch(error => {
                //console.log("[Member Actions] deleteEligibility error", error);
                dispatch(deleteEligibilityFailure(portalNameMessageDisplay));
                // Promise.reject(error);
        });
    }
}

export const deleteEligibilityStart = () => {
  return {
    type: actionTypes.DELETE_ELIGIBILITY_START,
  };
};

export const deleteEligibilitySuccess = (portalDisplay, mbrPortalId) => {
    return {
        type: actionTypes.DELETE_ELIGIBILITY_SUCCESS,
        portalShortNm: portalDisplay,
        memberPortalId: mbrPortalId
    }
}

export const deleteEligibilityFailure = (portalDisplay) => {
    return {
        type: actionTypes.DELETE_ELIGIBILITY_FAILURE,
        portalShortNm: portalDisplay
    }
}

export const setDeleteEligMsgToNull = () => {
  return {
    type: actionTypes.SET_DEL_ELIG_MESSAGE,
  };
};

export const bulkDisableAccounts = (file, token) => {
    return dispatch => {
        dispatch(bulkUserActivityStart());
        const config = {
          "headers": {
            'content-type': 'multipart/form-data',
            'Authorization': token
          }
        }
        adminDisableSvc.post("/upload", file, config).then(response => {
            //console.log("[Member Actions] bulkDisableAccounts: response", response.data);
            if(response.data) {
                dispatch(bulkDisableAccountsSuccess(response.data));
            }
        }).catch(error => {
            //console.log("bulkDisableAccounts error response: ", error);
            dispatch(bulkDisableAccountsFailure(error?.response?.data?.error));
        });
    }
}

export const bulkLockingAccounts = (file, token) => {
    return dispatch => {
        dispatch(bulkUserActivityStart());
        const config = {
          "headers": {
            'content-type': 'multipart/form-data',
            'Authorization': token
          }
        }
        adminDisableSvc.post("/users/lock/upload", file, config).then(response => {
            //console.log("[Member Actions] bulkDisableAccounts: response", response.data);
            if(response.data) {
                dispatch(bulkLockingAccountsSuccess(response.data));
            }
        }).catch(error => {
            //console.log("bulkDisableAccounts error response: ", error);
            dispatch(bulkLockingAccountsFailure(error?.response?.data?.error));
        });
    }
}

  export const bulkLdapUnlockAccounts = (file, token) => {
    return dispatch => {
      dispatch(bulkUserActivityStart());
      const config = {
        "headers": {
        'content-type': 'multipart/form-data',
        'Authorization': token
        }
      }
      adminDisableSvc.post(urls.BULK_LDAP_UNLOCK, file, config).then(response => {
        if(response.data) {
          dispatch(bulkLdapUnlockAccountsSuccess(response.data));
        }
      }).catch(error => {
        dispatch(bulkLdapUnlockAccountsFailure(error?.response?.data?.error));
      });
    }
  }

export const bulkDeleteAccounts = (file, token, skipOptions) => {
    const skipOptionParams = new URLSearchParams({
      skipHsidPdb : skipOptions?.skipHsidPdb ? "true" : "false",
      skipAikyam : skipOptions?.skipAikyam ? "true" : "false",
      skipKafka : skipOptions?.skipKafka ? "true" : "false"
    })

    return dispatch => {
        dispatch(bulkUserActivityStart());
        const config = {
          "headers": {
            'content-type': 'multipart/form-data',
            'Authorization': token
          }
        }
        adminDisableSvc.post("/users/delete/upload" + `?${skipOptionParams.toString()}`, file, config).then(response => {
            //console.log("[Member Actions] bulkDisableAccounts: response", response.data);
            if(response.data) {
                dispatch(bulkDeleteAccountsSuccess(response.data));
            }
        }).catch(error => {
            //console.log("bulkDisableAccounts error response: ", error);
            dispatch(bulkDeleteAccountsFailure(error?.response?.data?.error));
        });
    }
}

export const bulkEimpSyncUuids = (file, token) => {
    return dispatch => {
        dispatch(bulkUserActivityStart());
        const config = {
          "headers": {
            'content-type': 'multipart/form-data',
            'Authorization': token
          }
        }
        adminDisableSvc.post("/users/eimp-sync/upload", file, config).then(response => {
            if(response.data) {
                dispatch(bulkEimpSyncSuccess(response.data));
            }
        }).catch(error => {
            dispatch(bulkEimpSyncFailure(error?.response?.data?.error));
        });
    }
}

export const bulkDeleteWithFilenameAccounts = (fileData, token) => {
    return dispatch => {
        dispatch(bulkUserActivityStart());
        const config = {
          "headers": {
            'Authorization': token
          }
        }
        adminDisableSvc.post("/normal/bulk/delete/invocation", fileData, config).then(response => {
            //console.log("[Member Actions] bulkDisableAccounts: response", response.data);
            if(response.data) {
                dispatch(bulkDeleteAccountsSuccess(response.data));
            }
        }).catch(error => {
            //console.log("bulkDisableAccounts error response: ", error);
            dispatch(bulkDeleteAccountsFailure(error?.response?.data?.error));
        });
    }
}

export const bulkEimpSyncWithFilenameAccounts = (fileData, token) => {
    return dispatch => {
        dispatch(bulkUserActivityStart());
        const config = {
          "headers": {
            'Authorization': token
          }
        }
        adminDisableSvc.post("/normal/bulk/eimp-sync/invocation", fileData, config).then(response => {
            if(response.data) {
                dispatch(bulkEimpSyncSuccess(response.data));
            }
        }).catch(error => {
            dispatch(bulkEimpSyncFailure(error?.response?.data?.error));
        });
    }
}

export const bulkDeleteStop = (jobId, token) => {
    return dispatch => {
        dispatch(bulkUserActivityStart());
        const config = {
          "headers": {
            'Authorization': token
          }
        }
        adminDisableSvc.post("/normal/bulk/delete/stop?batchId="+jobId, {}, config).then(response => {
            //console.log("[Member Actions] bulkDisableAccounts: response", response.data);
            if(response.data) {
                dispatch(bulkUserActivityStop());
            }
        }).catch(error => {
            //console.log("bulkDisableAccounts error response: ", error);
            dispatch(bulkUserActivityStop());
        });
    }
}

export const bulkUserActivityStart = () => {
    return {
        type: actionTypes.BULK_USER_ACTIVITY_START,
    }
}

export const bulkUserActivityStop = () => {
    return {
        type: actionTypes.BULK_USER_ACTIVITY_STOP,
    }
}

export const bulkDisableAccountsSuccess = (bulkDisableResponse) => {
  return {
    type: actionTypes.BULK_DISABLE_SUCCESS,
    bulkDisableResponse: bulkDisableResponse,
  };
};

export const bulkDisableAccountsFailure = (error) => {
  return {
    type: actionTypes.BULK_DISABLE_FAILURE,
    error: error,
  };
};

export const bulkLockingAccountsSuccess = (bulkLockingResponse) => {
    return {
        type: actionTypes.BULK_LOCKING_SUCCESS,
        bulkLockingResponse: bulkLockingResponse
    }
}

export const bulkLockingAccountsFailure = (error) => {
    return {
        type: actionTypes.BULK_LOCKING_FAILURE,
        error: error
    }
}

  export const bulkLdapUnlockAccountsSuccess = (bulkLdapUnlockResponse) => {
    return {
      type: actionTypes.BULK_LDAP_UNLOCK_SUCCESS,
      bulkLdapUnlockResponse: bulkLdapUnlockResponse
    }
  }

  export const bulkLdapUnlockAccountsFailure = (error) => {
    return {
      type: actionTypes.BULK_LDAP_UNLOCK_FAILURE,
      error: error
    }
  }

export const bulkDeleteAccountsSuccess = (bulkDeleteResponse) => {
    return {
        type: actionTypes.BULK_DELETE_SUCCESS,
        bulkDeleteResponse: bulkDeleteResponse
    }
}

export const bulkDeleteAccountsFailure = (error) => {
    return {
        type: actionTypes.BULK_DELETE_FAILURE,
        error: error
    }
}

export const bulkEimpSyncSuccess = (bulkEimpSyncResponse) => {
    return {
        type: actionTypes.BULK_EIMP_SYNC_SUCCESS,
        bulkEimpSyncResponse: bulkEimpSyncResponse
    }
}

export const bulkEimpSyncFailure = (error) => {
    return {
        type: actionTypes.BULK_EIMP_SYNC_FAILURE,
        error: error
    }
}

export const setResponseToNull = () => {
  return {
    type: actionTypes.SET_BULKDISABLE_RESP_EMPTY,
  };
};

export const fetchPortalConfig = () => {
  return (dispatch) => {
    const sdkPortalList = localStorage.getItem(SDK_PORTAL_LIST)
    if (sdkPortalList != null) {
      dispatch(fetchPortalConfigSuccess(JSON.parse(sdkPortalList), true))
    }
    else if (SDK_ENABLE) {
      admSvc
        .get(urls.FETCH_PORTAL_CONFIG)
        .then((response) => {
          if (response.data.payload) {
            dispatch(fetchPortalConfigSuccess(response.data.payload, false));
          }
        })
        .catch((error) => {
          dispatch(fetchPortalConfigFailure(error));
        });
    } else {
      dispatch(fetchPortalConfigFailure("SDK Portal Fetching is Disabled"));
    }
  };
};

export const fetchPortalConfigSuccess = (portalConfig, storedPortal) => {
  let sdkPortalList = [];
  if(storedPortal) {
    sdkPortalList = portalConfig;
  }
  else{
    for (const key in portalConfig) {
      const element = portalConfig[key];
      let sdkPortal = {
        portalShortName : element['portalName'].toUpperCase(),
        portalDisplayName : element['uiConfig'].portalDisplayName,
        uiConfig: element['uiConfig'],
        portalDisplayUrl: element['uiConfig']?.locales?.en?.targetUrl,
        isSdkPortal: element['uiConfig'].features.isSDKPortal,
        isPePortal: element['uiConfig'].features.isPEPortal,
        isBaseAgentPortal: element['uiConfig'].features.isBaseAgentPortal,
        portalGroupName: element['uiConfig'].features.portalGroupName,
        adminDisabledOperations: element['uiConfig'].features.adminDisabledOperations
    };
      sdkPortalList.push(sdkPortal);
    }

    if (sdkPortalList) {
      localStorage.setItem(SDK_PORTAL_LIST, JSON.stringify(sdkPortalList));
    }
  }

  return {
    type: actionTypes.FETCH_PORTAL_CONFIG_SUCCESS,
    sdkPortalList: sdkPortalList,
  };
};

export const fetchPortalConfigFailure = (error) => {
  return {
    type: actionTypes.FETCH_PORTAL_CONFIG_FAILURE,
    error: error,
  };
};

export const resetMemResponse = () => {
  return {
    type: actionTypes.RESET_MEMRESPONSE,
  };
};

export const selectImpactedMember = (selectedMember, idType) => {
  return (dispatch) => {
    const id = selectedMember.uuid ? selectedMember.uuid : selectedMember.id;
    admSvc
      .get(
        "/search/account/memberIdEligibility/V3.0?id=" +
          id +
          "&idType=" +
          idType
      )
      .then((response) => {
        response.data.memberPayLoad.idType = idType;
        response.data.memberPayLoad.priImpactedFlag = "Impacted";
        dispatch(setIncidentMembersList([response.data.memberPayLoad]));
      })
      .catch((error) => {
        // Promise.reject(error);
        dispatch(fetchMemberDataFailure(error));
      });
  };
};

export const setIncidentMembersList = (memberList) => {
  return {
    type: actionTypes.SET_INCIDENT_MEMBERS_LIST,
    incidentMembersList: memberList,
  };
};

export const resetIncidentMembersList = (memberList) => {
  return {
    type: actionTypes.RESET_INCIDENT_MEMBERS_LIST,
    incidentMembersList: memberList,
  };
};

export const fetchImpactedMemberDataSuccess = (memberData, memberType) => {
  setToggleState(true);
  return {
    type: actionTypes.FETCH_IMPACTED_MEMBER_DATA_SUCCESS,
    impactedMemberData: memberData,
  };
};

export const setToggleState = (toggleState) => {
  return {
    type: actionTypes.SET_ACCOUNT_SECURITY_TOGGLE,
    toggleState: toggleState,
  };
};

export const clearEnableDisableStatusMsg = () =>{
  return {
    type: actionTypes.CLEAR_ENABLE_DISABLE_MSG
  };
}

export const fetchPasskeyList=(uuid)=>{
    return (dispatch) => {
    admSvc
      .get(
        "/member/passkey/list/" +uuid )
      .then((response) => {
        dispatch(fetchPasskeyListSuccess(response.data?.payload ?? []));
      })
      .catch((error) => {
        dispatch(fetchPasskeyListFailure([]));
      });
  };
}

export const togglePasskey=(data, passkeyList)=>{
    return (dispatch) => {
      dispatch({ type: actionTypes.PASSKEY_LOADING });
    admSvc
      .post(
        "/member/passkey/toggle", data )
      .then((response) => {
        if(response.data && response.data.status && response.data.status?.message === SUCCESS) {
          const updatedList = passkeyList.map(item => {
            if(item.credentialId === data.credentialId) {
              return {...item, enabled: !item.enabled};
            }
            return item;
          });
          dispatch(passkeyToggleSuccess(updatedList));
        } else {
          dispatch(passkeyToggleFailure());
        }
      })
      .catch((error) => {
        dispatch(passkeyToggleFailure());
      });
  };
}

export const deletePasskey=(data, passkeyList)=>{
    return (dispatch) => {
      dispatch({ type: actionTypes.PASSKEY_LOADING });
    admSvc
      .post(
        "/member/passkey/delete", data )
      .then((response) => {
        if(response.data && response.data.status && response.data.status?.message === SUCCESS) {
          const updatedArr = [...passkeyList]
          const idx = updatedArr.findIndex(item => item.credentialId === data.credentialId);
          updatedArr.splice(idx, 1);
          dispatch(passkeyDeleteSuccess(updatedArr));
        } else {
          dispatch(passkeyDeleteFailure());
        }
      })
      .catch((error) => {
        dispatch(passkeyDeleteFailure());
      });
  };
}

export const fetchPasskeyListSuccess = (list) => {
  return {
    type: actionTypes.FETCH_PASSKEY_LIST_SUCCESS,
    passkeyList: list,
  };
};

export const fetchPasskeyListFailure = (list) => {
  return {
    type: actionTypes.FETCH_PASSKEY_LIST_FAILURE,
    passkeyList: list,
  };
};

export const passkeyToggleSuccess = (list) => {
  return {
    type: actionTypes.PASSKEY_TOGGLE_SUCCESS,
    passkeyList: list,
  };
};

export const passkeyToggleFailure = () => {
  return {
    type: actionTypes.PASSKEY_TOGGLE_FAILURE,
  };
};

export const passkeyDeleteSuccess = (list) => {
  return {
    type: actionTypes.PASSKEY_DELETE_SUCCESS,
    passkeyList: list,
  };
};

export const passkeyDeleteFailure = () => {
  return {
    type: actionTypes.PASSKEY_DELETE_FAILURE,
  };
};